export const LEDGER_TAB = "LEGDER_TAB";
export const SETTLEMENT_TAB = "SETTLEMENT_TAB";
export const PAY_IN = "PAY_IN";
export const PAY_OUT = "PAY_OUT";
export const PREFUND_HISTORY = "PREFUND_HISTORY";
export const FUNDTRANSFER_TAB = "FUNDTRANSFER_TAB";
export const DEVELOPER_TAB = "DEVELOPER_TAB";

export const GENERATED_REPORTS = "GENERATED_REPORTS";
export const SCHEDULERS = "SCHEDULERS";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const CUSTOMERS_TAB = "CUSTOMERS_TAB";
export const BENEFICIARY_TAB = "BENEFICARY_TAB";

export const INTERVAL_TIME = 15 * 60;
